var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 20,
    height: 20,
    transform: "translate(1804 40)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_75",
    "data-name": "Mask Group 75",
    transform: "translate(-1804 -40)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1802.75 38.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M11.313,6.875a4.375,4.375,0,1,0,4.375,4.375A4.348,4.348,0,0,0,11.313,6.875Zm0,7.5a3.125,3.125,0,1,1,3.125-3.125A3.095,3.095,0,0,1,11.313,14.375Z",
    fill: "#ff0078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M20.5,9.188l-1.75-.562-.375-.937.875-1.625a1.051,1.051,0,0,0-.187-1.187l-1.5-1.5a1.051,1.051,0,0,0-1.187-.188l-1.625.875-.937-.375-.562-1.75a1.016,1.016,0,0,0-.937-.688H10.188A.876.876,0,0,0,9.313,2L8.75,3.75a2.761,2.761,0,0,0-1,.375L6.125,3.25a1.051,1.051,0,0,0-1.187.188l-1.5,1.5A1.051,1.051,0,0,0,3.25,6.125l.813,1.563c-.125.313-.25.688-.375,1l-1.75.562a1.016,1.016,0,0,0-.687.938v2.125A1,1,0,0,0,2,13.25l1.75.562.375.938L3.25,16.375a1.051,1.051,0,0,0,.188,1.187l1.5,1.5a1.051,1.051,0,0,0,1.188.188l1.625-.875.937.375.563,1.813a1.016,1.016,0,0,0,.938.688h2.125a1.016,1.016,0,0,0,.938-.687l.562-1.812.938-.375,1.625.875a1.051,1.051,0,0,0,1.187-.187l1.5-1.5a1.051,1.051,0,0,0,.188-1.187l-.875-1.625.375-.937,1.813-.562a1.016,1.016,0,0,0,.688-.938V10.188a1.07,1.07,0,0,0-.75-1ZM20,12.125l-2.25.688-.063.313-.562,1.313-.187.312,1.125,2.062-1.25,1.25L14.75,16.938l-.312.187a5.933,5.933,0,0,1-1.313.563l-.312.063L12.125,20h-1.75l-.688-2.25-.312-.063-1.313-.562-.312-.187L5.688,18.063l-1.25-1.25L5.563,14.75l-.188-.312a5.933,5.933,0,0,1-.562-1.313l-.062-.312L2.5,12.125v-1.75L4.625,9.75l.125-.312a5.305,5.305,0,0,1,.563-1.375L5.5,7.75,4.438,5.688l1.25-1.25,2,1.125L8,5.375a5.305,5.305,0,0,1,1.375-.562l.313-.125L10.375,2.5h1.75l.688,2.188.313.125a5.933,5.933,0,0,1,1.313.563l.312.188,2.062-1.125,1.25,1.25L16.938,7.75l.187.312a5.933,5.933,0,0,1,.563,1.313l.063.313,2.25.688Z",
    fill: "#ff0078"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.da107a5091c02b48dcf5d7631def08f9.svg";
export { ForwardRef as ReactComponent };